/* Partner Picks: category filters, copy-code buttons and view/click tracking.

   Events go to the partnerPickEvent Cloud Function as a text/plain beacon (no CORS
   preflight), same pattern as the parent-form visit beacon. Fire-and-forget: nothing
   here can block the outbound link. Events are also published to Shopify's customer
   events so a custom pixel (GA4, Omnisend, …) can pick them up later.
     page_view  once per page/strip load
     pick_view  card ≥50% visible, once per card per load
     pick_click outbound "Shop at …" link
     code_copy  Copy code button

   For a signed-in customer, clicks and copies also carry their Shopify customer ID
   and share_portal_token, so the function can send them to Omnisend and tag the
   customer (see the Partner Picks section of the privacy policy). Views never do.
   Identity is only sent once Shopify's consent API has loaded and says both
   marketing and sale/sharing of data are allowed. The data-sharing opt-out page
   and Global Privacy Control turn off sale/sharing, so either one stops it, and
   so does the API failing to load. */
(function () {
  if (window.__fsPartnerPicks) return;
  window.__fsPartnerPicks = true;

  var API = 'https://us-central1-firststamps-b9927.cloudfunctions.net/partnerPickEvent';
  var params = new URLSearchParams(location.search);
  var utm = {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || ''
  };

  // Random per-browser ID shared with the parent-form beacon. Not tied to a person.
  var visitor = null;
  try {
    visitor = localStorage.getItem('fs_visitor_id');
    if (!visitor && window.crypto && window.crypto.randomUUID) {
      visitor = window.crypto.randomUUID();
      localStorage.setItem('fs_visitor_id', visitor);
    }
  } catch (_) { visitor = null; }

  var queue = [];
  var flushTimer = null;

  // Load Shopify's consent API; the theme doesn't otherwise put it on the page.
  try {
    if (window.Shopify && typeof Shopify.loadFeatures === 'function' && !Shopify.customerPrivacy) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1', onLoad: function () {} }]);
    }
  } catch (_) {}

  // Only send identity when the consent API is loaded and allows both marketing and
  // sale/sharing of data. Anything missing or unknown counts as opted out.
  function identityAllowed() {
    try {
      if (navigator.globalPrivacyControl === true) return false;
      var privacy = window.Shopify && Shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.saleOfDataAllowed !== 'function') return false;
      return privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function send(events, identity) {
    if (!events.length) return;
    var payload = {
      events: events,
      page: location.pathname,
      utm_source: utm.utm_source,
      utm_medium: utm.utm_medium,
      utm_campaign: utm.utm_campaign,
      visitor_id: visitor
    };
    if (identity && identityAllowed()) {
      payload.customer_id = identity.customer_id;
      payload.portal_token = identity.portal_token;
    }
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(API, body)) return;
    } catch (_) {}
    try {
      fetch(API, { method: 'POST', body: body, mode: 'no-cors', credentials: 'omit', keepalive: true }).catch(function () {});
    } catch (_) {}
  }

  function flush(identity) {
    clearTimeout(flushTimer);
    flushTimer = null;
    send(queue.splice(0), identity);
  }

  function identityFor(root) {
    var id = root.getAttribute('data-pp-customer-id');
    var token = root.getAttribute('data-pp-portal-token');
    return id && token ? { customer_id: id, portal_token: token } : null;
  }

  // Views are batched; clicks and copies flush immediately (the page may be leaving).
  function track(event, root, card, immediate) {
    var data = {
      event: event,
      placement: root.getAttribute('data-pp-placement') || 'other',
      logged_in: root.getAttribute('data-pp-customer') === '1',
      ts: Date.now()
    };
    if (card) {
      data.pick_handle = card.getAttribute('data-pp-handle');
      data.brand = card.getAttribute('data-pp-brand');
      data.product_name = card.getAttribute('data-pp-name');
      data.category = card.getAttribute('data-pp-category');
    }
    queue.push(data);
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('partner_' + event, Object.assign({}, data, utm));
      }
    } catch (_) {}
    // Clicks and copies are the only events that flush immediately, so only they carry identity.
    if (immediate) flush(identityFor(root));
    else if (!flushTimer) flushTimer = setTimeout(function () { flush(); }, 1500);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); } catch (_) {}
      document.body.removeChild(input);
      resolve();
    });
  }

  function initFilters(root) {
    var chips = root.querySelectorAll('[data-pp-filter]');
    if (!chips.length) return;
    var cards = root.querySelectorAll('[data-pp-card]');
    var promos = root.querySelectorAll('[data-pp-promo]');
    var empty = root.querySelector('[data-pp-empty]');

    function apply(value, updateUrl) {
      var shown = 0;
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', String(chip.getAttribute('data-pp-filter') === value));
      });
      cards.forEach(function (card) {
        if (card.hasAttribute('data-pp-expired')) return;
        var match = !value || card.getAttribute('data-pp-category') === value;
        card.hidden = !match;
        if (match) shown++;
      });
      // The First Stamps card only sits in the unfiltered grid.
      promos.forEach(function (promo) { promo.hidden = !!value; });
      if (empty) empty.hidden = shown > 0;
      if (updateUrl && window.history.replaceState) {
        var url = new URL(location.href);
        if (value) url.searchParams.set('category', value);
        else url.searchParams.delete('category');
        history.replaceState(null, '', url);
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.getAttribute('data-pp-filter'), true);
      });
    });

    var initial = (params.get('category') || '').toLowerCase();
    var known = Array.prototype.some.call(chips, function (c) { return c.getAttribute('data-pp-filter') === initial; });
    if (initial && known) apply(initial, false);
  }

  function initRoot(root) {
    var now = Date.now() / 1000;
    var cards = root.querySelectorAll('[data-pp-card]');

    // Liquid hides expired picks, but cached pages can lag; hide them client-side too.
    cards.forEach(function (card) {
      var exp = parseInt(card.getAttribute('data-pp-expires'), 10);
      if (exp && exp < now) {
        card.hidden = true;
        card.setAttribute('data-pp-expired', '');
      }
    });

    initFilters(root);
    track('page_view', root, null, false);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.setAttribute('data-pp-viewed', '');
          track('pick_view', root, entry.target, false);
        });
      }, { threshold: 0.5 });
      cards.forEach(function (card) {
        if (!card.hidden) observer.observe(card);
      });
      // Cards revealed later by a filter are observed when they become visible.
      root.addEventListener('click', function (e) {
        if (!e.target.closest('[data-pp-filter]')) return;
        cards.forEach(function (card) {
          if (!card.hidden && !card.hasAttribute('data-pp-viewed')) observer.observe(card);
        });
      });
    }

    root.addEventListener('click', function (e) {
      var out = e.target.closest('[data-pp-out]');
      if (out) {
        track('pick_click', root, out.closest('[data-pp-card]'), true);
        return;
      }
      var copy = e.target.closest('[data-pp-copy]');
      if (copy) {
        var card = copy.closest('[data-pp-card]');
        var label = copy.textContent;
        copyText(copy.getAttribute('data-pp-copy')).then(function () {
          copy.textContent = copy.getAttribute('data-copied-label') || label;
          setTimeout(function () { copy.textContent = label; }, 2000);
        });
        track('code_copy', root, card, true);
      }
    });

    // Middle-click / "open in new tab" don't fire click.
    root.addEventListener('auxclick', function (e) {
      var out = e.target.closest('[data-pp-out]');
      if (out && e.button === 1) track('pick_click', root, out.closest('[data-pp-card]'), true);
    });
  }

  function highlightTarget() {
    if (!location.hash) return;
    var el;
    try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (_) { return; }
    if (!el || !el.hasAttribute('data-pp-card') || el.hidden) return;
    el.classList.add('pp-card--highlight');
    el.scrollIntoView({ block: 'center' });
  }

  function init() {
    document.querySelectorAll('[data-pp-root]').forEach(initRoot);
    highlightTarget();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
